import { render } from "./Application.md?vue&type=template&id=54226fc7"
const script = {}
script.render = render

export default script